module.exports = __webpack_public_path__ + "img/open-graph.2574f6dd.jpg";